import { MARQUEE_WORDS } from "@/content/navigation";

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-5 w-5 shrink-0 text-gold sm:mx-12 sm:h-6 sm:w-6" aria-hidden="true">
    <path fill="currentColor" d="M12 0c.6 6.4 5.6 11.4 12 12-6.4.6-11.4 5.6-12 12-.6-6.4-5.6-11.4-12-12C6.4 11.4 11.4 6.4 12 0Z" />
  </svg>
);

export const Marquee = ({ words = MARQUEE_WORDS, tone = "dark" }) => {
  const row = [...words, ...words];
  return (
    <div
      className={`marquee relative overflow-hidden border-y py-7 sm:py-10 ${tone === "dark" ? "border-white/10 bg-ink" : "border-ink/10 bg-ivory"}`}
      data-testid="editorial-marquee"
      aria-label={words.join(", ")}
    >
      <div className="marquee-track" aria-hidden="true">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`whitespace-nowrap font-display text-4xl font-light italic tracking-tight sm:text-6xl lg:text-7xl ${
                i % 2 ? "text-gold-metal" : tone === "dark" ? "text-white/90" : "text-ink"
              }`}
            >
              {w}
            </span>
            <Star />
          </span>
        ))}
      </div>
    </div>
  );
};
